import { useState } from "react";
import { MapPin } from "lucide-react";
import { MAP_QUERY, FULL_ADDRESS } from "@/lib/company";

export const MapEmbed = ({ className = "h-80" }) => {
  const [loaded, setLoaded] = useState(false);
  if (loaded) {
    return (
      <iframe
        title="Mappa sede LINCESSO GROUP TRASPORTI"
        src={`https://maps.google.com/maps?q=${MAP_QUERY}&z=16&output=embed`}
        className={`w-full border-0 grayscale-[30%] ${className}`}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        data-testid="map-iframe"
      />
    );
  }
  return (
    <div className={`relative w-full overflow-hidden bg-[#14161A] speed-lines flex flex-col items-center justify-center text-center p-6 ${className}`} data-testid="map-placeholder">
      <MapPin className="h-10 w-10 text-[#E50914]" />
      <p className="mt-3 text-white font-semibold">{FULL_ADDRESS}</p>
      <p className="mt-2 text-xs text-slate-400 max-w-xs">La mappa è fornita da Google Maps e viene caricata solo dopo il tuo consenso.</p>
      <div className="mt-5 flex flex-wrap gap-3 justify-center">
        <button onClick={() => setLoaded(true)} className="bg-[#E50914] hover:bg-[#C10710] text-white px-5 py-2.5 text-xs font-bold uppercase tracking-wider transition-colors" data-testid="map-load-btn">
          Mostra mappa
        </button>
        <a href={`https://www.google.com/maps/search/?api=1&query=${MAP_QUERY}`} target="_blank" rel="noopener noreferrer" className="border border-white/20 hover:border-white text-white px-5 py-2.5 text-xs font-bold uppercase tracking-wider transition-colors" data-testid="map-directions-link">
          Indicazioni stradali
        </a>
      </div>
    </div>
  );
};
